import {
  getImageUrl,
  getItemCode,
  getPartNumber,
  getProductDescription
} from "./chunk-P7U6L3AP.mjs";
import {
  generateProductItemUrl
} from "./chunk-XV7TMGN6.mjs";

// src/SearchResultsTable.tsx
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table/index.js";
import TableBody from "@mui/material/TableBody/index.js";
import TableCell from "@mui/material/TableCell/index.js";
import TableContainer from "@mui/material/TableContainer/index.js";
import TableHead from "@mui/material/TableHead/index.js";
import TableRow from "@mui/material/TableRow/index.js";
import Paper from "@mui/material/Paper/index.js";
import Box from "@mui/material/Box/index.js";
import Chip from "@mui/material/Chip/index.js";
import Typography from "@mui/material/Typography/index.js";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/esm/ImageNotSupportedOutlined.js";
import { useTranslation } from "react-i18next";
import { jsx, jsxs } from "react/jsx-runtime";
var CELL_SX = {
  padding: { xs: "8px 4px", sm: "16px 12px" }
};
var HIDE_ON_MOBILE_SX = {
  display: { xs: "none", sm: "table-cell" }
};
var ImageCell = ({ src, alt }) => {
  const size = { xs: 36, sm: 56 };
  if (!src) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: "action.hover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.disabled"
        },
        children: /* @__PURE__ */ jsx(ImageNotSupportedOutlinedIcon, { sx: { fontSize: { xs: 18, sm: 24 } } })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "img",
      src,
      alt,
      sx: {
        width: size,
        height: size,
        objectFit: "contain",
        borderRadius: 1
      }
    }
  );
};
var SearchResultsTable = ({
  results,
  idToName
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleRowClick = (categoryName, itemCode) => {
    if (!categoryName || !itemCode) return;
    navigate(generateProductItemUrl(categoryName, itemCode));
  };
  return /* @__PURE__ */ jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxs(
    Table,
    {
      sx: {
        "& .MuiTableCell-root": {
          fontSize: { xs: "0.75rem", sm: "0.875rem" }
        }
      },
      children: [
        /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
          /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: t("searchResults.columnImage") }),
          /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: t("searchResults.columnItemCode") }),
          /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: t("searchResults.columnPartNumber") }),
          /* @__PURE__ */ jsx(TableCell, { sx: { ...CELL_SX, ...HIDE_ON_MOBILE_SX }, children: t("searchResults.columnDescription") }),
          /* @__PURE__ */ jsx(TableCell, { sx: { ...CELL_SX, ...HIDE_ON_MOBILE_SX }, children: t("searchResults.columnCategory") })
        ] }) }),
        /* @__PURE__ */ jsx(TableBody, { children: results.map((item, index) => {
          const categoryName = idToName.get(
            String(
              item.groupid ?? item.groupId ?? ""
            )
          );
          const itemCode = getItemCode(item);
          const clickable = Boolean(categoryName && itemCode);
          return /* @__PURE__ */ jsxs(
            TableRow,
            {
              hover: clickable,
              onClick: () => handleRowClick(categoryName, itemCode),
              sx: { cursor: clickable ? "pointer" : "default" },
              children: [
                /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: /* @__PURE__ */ jsx(
                  ImageCell,
                  {
                    src: getImageUrl(item),
                    alt: getPartNumber(item) || itemCode
                  }
                ) }),
                /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: /* @__PURE__ */ jsx(Typography, { variant: "inherit", fontWeight: 700, children: itemCode }) }),
                /* @__PURE__ */ jsx(TableCell, { sx: CELL_SX, children: /* @__PURE__ */ jsx(Typography, { variant: "inherit", children: getPartNumber(item) }) }),
                /* @__PURE__ */ jsx(TableCell, { sx: { ...CELL_SX, ...HIDE_ON_MOBILE_SX }, children: /* @__PURE__ */ jsx(Typography, { variant: "inherit", color: "text.secondary", children: getProductDescription(item) }) }),
                /* @__PURE__ */ jsx(TableCell, { sx: { ...CELL_SX, ...HIDE_ON_MOBILE_SX }, children: categoryName && /* @__PURE__ */ jsx(
                  Chip,
                  {
                    label: categoryName,
                    size: "small",
                    variant: "outlined"
                  }
                ) })
              ]
            },
            index
          );
        }) })
      ]
    }
  ) });
};

export {
  SearchResultsTable
};
